<div class="col-sm-12" *ngIf="rows.length > 0">
    <small id="form-dettaglio-{{file.refDocumentale}}" class="sr-only"> Form di dettaglio file {{file.nomeFile}}</small>
    <form aria-labelledby="form-dettaglio-{{file.refDocumentale}}" [formGroup]="form">
        <table class="table-striped">
            <caption class="sr-only">Tabella dettaglio file {{file.nomeFile}}</caption>
            <thead>
                <tr>
                    <th>Titolo</th>
                    <th>Produttore Copia</th>
                    <th *ngIf="!isSigned">Firmatario/i</th>
                    <th>Azione</th>
                </tr>
            </thead>

            <tbody formArrayName="rows">
                <tr *ngFor="let row of rows.controls; let i = index" [formGroupName]="i">

                    <td>
                        <input type="text" aria-label="inserisci dettaglio riga numero {{i+1}}" placeholder="Inserisci titolo"
                            class="form-control" formControlName="titolo">
                    </td>
                    <td>
                        <input type="text" aria-label="inserisci dettaglio riga numero {{i+1}}"
                            placeholder="Inserisci produttore" class="form-control" formControlName="produttore">
                    </td>
                    <td *ngIf="!isSigned">
                        <input type="text" aria-label="inserisci dettaglio riga numero {{i+1}}"
                            placeholder="Inserisci firmatario/i" class="form-control" formControlName="firmatari">
                    </td>

                    <td>
                        <button type="button" role="button" class="btn-link" (click)="removeRow(i)"
                            aria-label="Elimina dettaglio" [appTooltip]="'Elimina dettaglio'"
                            [appTooltipEnabled]="true">
                            <span class="glyphicon glyphicon-remove"></span>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>

        <!-- <button class="btn btn-primary" (click)="addRow()">Aggiungi riga</button>
      <button class="btn btn-success" (click)="save()">Salva</button> -->

    </form>
</div>